// src/storyEngine.js

export const applyMastersGuide = (storyName, genre, date) => {
  return {
    manuscriptSpecs: { genre, tone: "Vibrant & Modern", perspective: "Third Person", wordCountTarget: "85k-100k words", pacing: "Viral" },
    marketLogic: { optimalWordCount: "Best-Seller Standard", marketWhy: "2026 Engagement Optimized" },
    writingPlan: { dailyGoal: "500 words", weeklyGoal: "1 Draft", revisionPlan: "Sanderson/Martin/Rowling Polish" },
    worldBuilding: { setting: "Modern Reimagining", themes: "Resilience & Heritage" }
  };
};

export const getStoryForDate = (date) => {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  
  const allStories = [
    "Hansel and Gretel", "Little Red Riding Hood", "Cinderella", "Rapunzel", "Rumpelstiltskin", "Snow White", "Bremen Town Musicians", "The Fisherman and His Wife", "The Frog Prince", "The Goose Girl",
    "The Brave Little Tailor", "The Twelve Dancing Princesses", "The Wolf and the Seven Little Kids", "The Golden Goose", "The Queen Bee", "The Elves and the Shoemaker", "The Juniper Tree", "The White Snake", "The Devil with the Three Golden Hairs", "The Six Swans",
    "The Seven Ravens", "The Blue Light", "The Singing Bone", "The Water of Life", "The King of the Golden Mountain", "The Two Brothers", "The Three Little Birds", "The Donkey Cabbage", "The Iron Stove", "The Bearskinner",
    "Aladdin", "Ali Baba", "Sinbad Voyage 1", "The Star Money", "The Master Thief", "The Glass Coffin", "The Lazy Spinner", "The Strong Hans", "The Griffin", "The Hut in the Forest"
  ];

  // Logic Hari ke-X dalam setahun (Jan 1 = 0)
  const start = new Date(y, 0, 1);
  const diff = Math.floor((date - start) / 86400000);
  
  let story = allStories[diff % allStories.length];
  let genre = "General Folklore";

  // Override untuk Jan 31 spesifik (Hari Ini)
  if (m === 0 && d === 31) { story = "Aladdin"; genre = "Epic Adventure"; }

  const monthStr = String(m + 1).padStart(2, '0');
  const dayStr = String(d).padStart(2, '0');
  const fileName = `${y}-${monthStr}-${dayStr}-story.md`;

  return { name: story, genre, fileName, ...applyMastersGuide(story, genre, date) };
};